import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.52 1.333a5.333 5.333 0 0 0-4.212 8.604l-3.592 3.592a.667.667 0 1 0 .943.942L6.25 10.88a5.333 5.333 0 1 0 3.27-9.547M8.343 3.155a1.67 1.67 0 0 1 1.179-.488 4 4 0 0 1 2.666 1.018 3 3 0 0 0-3.233 2.216 1.667 1.667 0 0 1-.612-2.746m-.942 3.3a3 3 0 0 0 1.355.779 1.666 1.666 0 0 1-3.234-.567A4 4 0 0 1 6.539 4a3 3 0 0 0 .86 2.455m2.688.978a3 3 0 0 1-3.234 2.215 4 4 0 0 0 2.66 1.019h.007a1.667 1.667 0 0 0 .567-3.234m2.414 1.9a4 4 0 0 0 1.019-2.66v-.006a1.667 1.667 0 0 0-3.234-.568 3 3 0 0 1 2.215 3.234",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })